module.exports = __webpack_public_path__ + "static/media/icono_mis_servicios.08f0e10c.svg";